// extracted by mini-css-extract-plugin
export default {"wrapper":"NiG0Ny5ZBZplqTKagdHc","breadcrumb":"KupN6kl2EEVPd0y25QeK","content":"yaeIYIfCZQwq_18R1MXJ"};